var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 39,
    viewBox: "0 0 31 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 22.9998C19.5616 22.9998 23.0001 19.5613 23.0001 15.3332C23.0001 11.105 19.5616 7.6665 15.3334 7.6665C11.1052 7.6665 7.66675 11.105 7.66675 15.3332C7.66675 19.5613 11.1052 22.9998 15.3334 22.9998ZM15.3334 11.4998C17.4475 11.4998 19.1667 13.2191 19.1667 15.3332C19.1667 17.4473 17.4475 19.1665 15.3334 19.1665C13.2193 19.1665 11.5001 17.4473 11.5001 15.3332C11.5001 13.2191 13.2193 11.4998 15.3334 11.4998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2218 37.9768C14.5462 38.2085 14.9349 38.333 15.3335 38.333C15.7321 38.333 16.1208 38.2085 16.4452 37.9768C17.0278 37.5647 30.7224 27.6767 30.6668 15.3333C30.6668 6.87892 23.7879 0 15.3335 0C6.87909 0 0.000168739 6.87892 0.000168739 15.3238C-0.0554146 27.6767 13.6392 37.5647 14.2218 37.9768ZM15.3335 3.83333C21.6758 3.83333 26.8335 8.99108 26.8335 15.3429C26.8738 23.8491 18.4232 31.487 15.3335 33.9921C12.2458 31.4851 3.79325 23.8453 3.8335 15.3333C3.8335 8.99108 8.99125 3.83333 15.3335 3.83333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.108cd3b982e4ca6093ecedd830b4a89c.svg";
export { ForwardRef as ReactComponent };